/**
 * Beyond Subscription Types slug enums based on Docebo and Genesys Learning Subscriptions
 */
export enum SubscriptionType {
  AGENT_PLATFORM_SUBSCRIPTION = 'agent-platform',
  AP_ENGLISH = 'ap-nov2024-english',
  AP_SPANISH = 'ap-spanish',
  AP_PORTUGUESE = 'ap-portuguese',
  AI_ESSENTIAL_SUBSCRIPTION = 'ai-essentials',
  GENESYS_ENGAGE_SUBSCRIPTION = 'genesys-engage-learning-subscription',
  POINTILLIST_SUBSCRIPTION = 'pointillist-learning-subscription',
  PURECONNECT_SUBSCRIPTION = 'pureconnect-learning-subscription',
  GENESYS_CLOUD_SUBSCRIPTION = 'genesys-cloud-learning-subscription',
  GENESYS_CLOUD_PARTNER_DIGITAL_SUBSCRIPTION = 'genesys-cloud-cx-partner-digital-subscription', // New
  GENESYS_CLOUD_PARTNER_DIGITAL_PLUS = 'genesys-cloud-cx-partner-digital-plus', // New
  GENESYS_CLOUD_PREMIER_PARTNER_SUBSCRIPTION = 'genesys-cloud-cx-premier-partner-learning-subscription', // New
  GENESYS_CLOUD_TRIAL_SUBSCRIPTION = 'genesys-cloud-cx-trial-subscription', // New
  AGENT_PLATFORM_AP_SUBSCRIPTION = 'agent-platform-ap', // Wordpress Generated Slug by Name
  GENESYS_CLOUD_CX_SUBSCRIPTION = 'genesys-cloud-cx-learning-subscription', // Wordpress Generated Slug by Name
  // TODO: Need to remove these
  GENESYS_CLOUD_LEARNING_SUBSCRIPTION = 'Genesys Cloud Learning Subscription',
  GENESYS_ENGAGE_LEARNING_SUBSCRIPTION = 'Genesys Engage on-premises Learning Subscription',
  LEGACY_GENESYS_CLOUD_LEARNING_SUBSCRIPTION = 'Genesys Cloud CX Learning Subscription',
  LEGACY_GENESYS_ENGAGE_LEARNING_SUBSCRIPTION = 'Genesys Engage Learning Subscription',
  LEGACY_PURECONNECT_LEARNING_SUBSCRIPTION = 'PureConnect Learning Subscription',
  POINTILLIST_LEARNING_SUBSCRIPTION = 'Pointillist Learning Subscription',
}
